import type { SVGProps } from 'react';

export const HandThumbsupFillSFSymbolMedium = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.3142 21.1367"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="21.1367" opacity="0" width="20.3142" x="0" y="0" />{' '}
        <path
          d="M0 14.1744C0 17.2074 1.88222 19.7031 4.39726 19.7031L6.09667 19.7031C4.32656 18.357 3.54765 16.3549 3.55644 14.0732C3.56797 11.6178 4.45195 9.83455 5.37265 8.61816L4.02714 8.61816C1.75097 8.61816 0 11.0498 0 14.1744ZM4.98144 14.0928C4.97265 17.8189 7.90878 20.6484 12.5816 20.6537L13.9431 20.6554C15.217 20.6572 16.1967 20.5676 16.7574 20.4193C17.607 20.2144 18.3517 19.6789 18.3517 18.7222C18.3517 18.3449 18.2576 18.0644 18.1439 17.8523C18.0728 17.7342 18.0924 17.6488 18.1955 17.6035C18.8361 17.3074 19.3218 16.7146 19.3218 15.9308C19.3218 15.4861 19.1984 15.0849 18.9836 14.8002C18.8902 14.6695 18.9017 14.5469 19.0609 14.4615C19.5082 14.1795 19.8242 13.6045 19.8242 12.9451C19.8242 12.4633 19.6759 11.9742 19.4203 11.7187C19.2851 11.5961 19.3109 11.5072 19.4478 11.3801C19.7611 11.1068 19.9529 10.6357 19.9529 10.0703C19.9529 9.05897 19.1625 8.23827 18.1324 8.23827L14.607 8.23827C13.7537 8.23827 13.2004 7.80487 13.2004 7.11386C13.2004 5.80272 14.8769 3.3371 14.8769 1.55156C14.8769 0.587107 14.247 0 13.4133 0C12.6803 0 12.2998 0.478516 11.8865 1.28652C10.398 4.17031 8.42401 6.51347 6.90897 8.51933C5.59745 10.2603 4.98847 11.7539 4.98144 14.0928Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
